<template>
  <div>
    <Popover v-slot="{ open, close }" class="relative">
      <Float
        :offset="10"
        :auto-placement="{
          autoAlignment: true,
          allowedPlacements: ['bottom-end', 'top-end']
        }"
      >
        <PopoverButton
          :class="
            open
              ? 'border-primary-400 dark:border-primary-500 border'
              : 'text-opacity-90 border'
          "
          class="group hover:text-opacity-100 inline-flex items-center justify-between gap-3 rounded-md px-3 py-2 font-medium dark:border"
        >
          <FontAwesomeIcon
            class="group-hover:text-opacity-80 h-4 transition duration-150 ease-in-out"
            :class="open ? '' : 'text-opacity-70'"
            :icon="['fal', 'plus']"
          />
          <span class="capitalize-first text-xs font-medium">{{
            $t('global.new_column')
          }}</span>
        </PopoverButton>
        <PopoverPanel class="popover-panel w-screen max-w-sm md:w-120">
          <div class="grid gap-4 p-4 lg:grid-cols-2">
            <template
              v-for="(type, index) in metadata.enums.columns_types.filter(
                (type) => type.selectable
              )"
              :key="index"
            >
              <BaseButton
                class="bg-opacity-80"
                :data-tint="type.color"
                :title="$t('button.' + type.id)"
                :icon="type.icon"
                color="primary"
                @click="() => addColumn(type, close)"
              />
            </template>
          </div>
        </PopoverPanel>
      </Float>
    </Popover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { Float } from '@headlessui-float/vue'

export default {
  name: 'AddNewColumnComponent',
  components: {
    Float,
    BaseButton,
    FontAwesomeIcon,
    Popover,
    PopoverButton,
    PopoverPanel
  },
  emits: ['add-column'],
  computed: {
    ...mapGetters({
      metadata: 'metadata/getInitialMetadata',
      auth: 'auth/getAuth'
    })
  },
  methods: {
    addColumn(type, close) {
      this.$emit('add-column', {
        type: type.id,
        label: { [this.$i18n.locale]: type.name },
        field: null,
        class: null,
        search: { searchable: false, value: null },
        sort: { sortable: false, value: null }
      })
      close()
    }
  }
}
</script>

<style scoped></style>
